var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-div"},[_c('div',{ref:"mainPage",staticClass:"main-page"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],ref:"gameIframe",attrs:{"src":_vm.gameUrl,"frameborder":"0","scrolling":"no","width":"100%","height":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }